import omit from 'lodash/omit';
import TextField from '@mui/material/TextField';
import CustomInput from './CustomInput';
import './CustomTextField.scss';

const CustomTextField = props => (
  <CustomInput {...omit(props, 'children')}>
    <TextField
      className={`CustomTextField ${props.rounded && 'custom-text-field-rounded'}`}
      style={{
        ...(props.style || {}),
        backgroundColor: 'white',
      }}
      size={props?.size || 'medium'}
      fullWidth={props?.fullWidth || false}
      sx={{
        ...(props.sx || {}),
      }}
      autoComplete={props?.autoComplete}
      inputProps={{
        maxLength: props?.maxLength,
      }}
      {...omit(props, 'helperText', 'label', 'style', 'sx', 'className')}
      {...(props.formHookProps || {})}
      onChange={e => props.onChange(e, e.target.value)}
    />
  </CustomInput>
);

export default CustomTextField;
